import Badges from "../../components/common/badges";
import Ingredients from "../../components/common/ingredients";
import ProductLabel from "../../components/common/product-label";
import TopNavBar from "../../components/glucogen/top-nav-bar";
import AllStartedCake from "../../components/glucogen/tsl/all-started-cake";
import BreakFree from "../../components/glucogen/tsl/break-free";
import DiabeticCustomer from "../../components/glucogen/tsl/diabetic-customer";
import DiscoveryBuried from "../../components/glucogen/tsl/discovery-buried";
import EatingCake from "../../components/glucogen/tsl/eating-cake";
import EnjoyingCake from "../../components/glucogen/tsl/enjoying-cake";
import FreedomPossible from "../../components/glucogen/tsl/freedom-possible";
import HowIMet from "../../components/glucogen/tsl/how-i-met";
import ImDaniel from "../../components/glucogen/tsl/im-daniel";
import MgDl from "../../components/glucogen/tsl/mg-dl";
import ShiftUnexpected from "../../components/glucogen/tsl/shift-unexpected";
import SomethingCalled from "../../components/glucogen/tsl/something-called";
import TestimonialsTsl from "../../components/glucogen/tsl/testimonials-tsl";
import ShatteredBeliefs from "../../components/glucogen/tsl/turning-point";
import YouNext from "../../components/glucogen/tsl/you-next";
import { glucoGenIngredients } from "../../data/ingredients";
import usePageTracking from "../../utils/gtm-page-tracking";
import productLabelImg from "../../assets/img/product-gg-label-bottle.png";
import productLabelImgWebp from "../../assets/img/product-gg-label-bottle.webp";
import Faq from "../../components/glucogen/faq";
import Buy from "../../components/glucogen/buy";
import CountdownTimer from "../../components/common/countdown";
import MoneyBackGuaranteeTsl from "../../components/glucogen/tsl/money-back-guarantee-tsl";
import SystemErase from "../../components/glucogen/tsl/system-erase";
import BuyTitle from "../../components/glucogen/tsl/buy-title";
import { useEffect } from "react";
import { ggProductName } from "../../data/product";
import useScrollToHash from "../../utils/scroll-to-hash";

const TslPage = () => {
    usePageTracking();
    useScrollToHash();
    useEffect(() => {
        const script1 = document.createElement('script');
        script1.innerHTML = `
            var mysrc = "https://tracking.buygoods.com/track/?a=11273&firstcookie=0"+"&tracking_redirect=&referrer="+encodeURIComponent(document.referrer)+"&sessid2="+ReadCookie('sessid2')+"&product=glu1,glu3,glu6&vid1=&vid2=&vid3=&caller_url="+encodeURIComponent(window.location.href); if(typeof add_to_cart !== 'undefined') { mysrc = mysrc+'&add_to_cart='+add_to_cart; } var newScript = document.createElement('script'); newScript.type = 'text/javascript'; newScript.defer = true; newScript.src = mysrc; var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(newScript, s); function ReadCookie(name){name += '='; var parts = document.cookie.split(/;\s*/);for (var i = 0; i < parts.length; i++) {var part = parts[i]; if (part.indexOf(name) == 0) return part.substring(name.length)} return '';}
        `;
        const script2 = document.createElement('script');
        script2.type = 'text/javascript';
        script2.innerHTML = `
            setTimeout(function () {var i = document.createElement("iframe"),oid = new URLSearchParams(window.location.search);i.async = true;i.style="display:none";i.setAttribute("src", "https://buygoods.com/affiliates/go/conversion/iframe/bg?a=11273&t=d9e2485e36c8c19cbfc7f6acfe589a47&s="+ReadCookie('sessid2'));document.body.appendChild(i);}, 1000);
        `;

        document.head.appendChild(script1);
        document.head.appendChild(script2);

        return () => {
            document.head.removeChild(script1);
            document.head.removeChild(script2);
        };
    }, []);

    return (
        <>
            <TopNavBar />
            <DiabeticCustomer />
            <MgDl />
            <FreedomPossible />
            <ImDaniel />
            <ShatteredBeliefs />
            <AllStartedCake />
            <EatingCake />
            <EnjoyingCake />
            <HowIMet />
            <BreakFree />
            <SomethingCalled />
            <Ingredients
                ingredients={glucoGenIngredients}
                backgroundClass="gg-bg-solid-green"
                title="This original blend of GlucoGen<sup>17</sup> Naturals contains 17 carefully selected ingredients including:"
            />
            <Badges />
            <ShiftUnexpected />
            <DiscoveryBuried />
            <TestimonialsTsl />
            <YouNext />
            <CountdownTimer
                title={`Get your ${ggProductName} supply today`}
                backgroundClass=""
                digitClass="gg-countdown-digit"
            />
            <Buy
                isShown={true}
                showExtraLinks={true}
            />
            <SystemErase />
            <BuyTitle />
            <Buy
                isShown={true}
                showExtraLinks={true}
            />
            <MoneyBackGuaranteeTsl />
            <Faq />
            <ProductLabel
                image={productLabelImg}
                imageWebp={productLabelImgWebp}
                backgroundClass="gg-bg-gradient-v"
            />
        </>
    );
};

export default TslPage;